"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SkipToContent = require("./SkipToContent");

Object.keys(_SkipToContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SkipToContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SkipToContent[key];
    }
  });
});